import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import './index.css'
import App from './App'
// import reportWebVitals from './reportWebVitals'

import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 776,
      lg: 1290,
      xl: 1480,
    },
  },
  // palette: {
  //   main: '#1c2445',
  //   darkGrey: '#33323099',
  //   grey: '#ABABAB',
  //   lightGrey: '#cdcdcd',
  // },
  palette: {
    main: '#CFCFCF',
    darkGrey: '#B8B8B8',
    grey: '#7D7D7D',
    lightGrey: '#868686',
  }
});


const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
